import template from './securityBadgeList.html';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    item: '<',
  },
};
